import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  deliveryModes: [],
  isLoading: true,
  isViewModalOpen: false,
  isDeleteModalOpen: false,
  viewSingleDeliveryModes: {},
};

export const fetchDeliveryModes = createAsyncThunk(
  "deliveryModes/fetchDeliveryModes",
  () => {
    return axios
      .get("https://62de2ff379b9f8c30ab47809.mockapi.io/deliveryModes")
      .then((response) => response.data);
  }
);

const deliveryModesSlice = createSlice({
  name: "deliveryModes",
  initialState,
  reducers: {
    viewDeliveryModes: (state, action) => {
      state.isViewModalOpen = true;
      state.viewSingleDeliveryModes = action.payload;
    },
    openDeleteModal: (state, action) => {
      state.isDeleteModalOpen = true;
      state.viewSingleDeliveryModes = action.payload;
    },
    closeModal: (state) => {
      state.isViewModalOpen = false;
      state.isDeleteModalOpen = false;
      state.viewSingleDeliveryModes = {};
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchDeliveryModes.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchDeliveryModes.fulfilled, (state, action) => {
      state.isLoading = false;
      state.deliveryModes = action.payload;
      state.error = "";
    });
    builder.addCase(fetchDeliveryModes.rejected, (state, action) => {
      state.isLoading = false;
      state.deliveryModes = [];
      state.error = action.error.message;
    });
  },
});

export const { viewDeliveryModes, openDeleteModal, closeModal } =
  deliveryModesSlice.actions;
export default deliveryModesSlice.reducer;
